/*
 * Copyright (c) 2020. FINN Sp. z o.o.
 */

package pl.finn.forms.podpp

import io.kvision.navigo.Navigo
import io.kvision.routing.Routing
import pl.finn.forms.App
import pl.finn.forms.utils.stringProperty

fun Routing.podppRouting(app: App): Navigo {
    return on("/pismo_ogolne_do_podmiotu_publicznego_nowy/:token", { params ->
        Model.nowy(stringProperty(params, "token"), app)
    }).on("/pismo_ogolne_do_podmiotu_publicznego_edycja/:token", { params ->
        Model.edycja(stringProperty(params, "token"), app)
    })
}

